import React from 'react';
import { NavLink } from 'react-router-dom';
import { Shield, Users, Grid3X3 } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';

const Admin: React.FC = () => {
  const { user } = useAuth();
  const isAdmin = user?.is_superuser === 1;

  if (!isAdmin) {
    return (
      <div className="p-6">
        <div className="flex items-center gap-3 mb-4">
          <Shield className="w-6 h-6 text-[#B1B5C3]" />
          <div className="text-xl font-semibold">Админка</div>
        </div>
        <div className="text-[#B1B5C3]">Недостаточно прав.</div>
      </div>
    );
  }

  return (
    <div className="p-6 space-y-4">
      <div className="flex items-center gap-3">
        <Shield className="w-6 h-6 text-blue-400" />
        <div className="text-xl font-semibold">Админка</div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <NavLink
          to="/admin/users"
          className="p-4 rounded-xl bg-[#181A20] border border-[#23262F] hover:border-blue-500 transition"
        >
          <div className="flex items-center gap-3 mb-1">
            <Users className="w-5 h-5 text-[#B1B5C3]" />
            <div className="text-white font-semibold">Пользователи</div>
          </div>
          <div className="text-sm text-[#B1B5C3]">Разрешение/блокировка, удаление пользователей.</div>
        </NavLink>

        <NavLink
          to="/admin/apps"
          className="p-4 rounded-xl bg-[#181A20] border border-[#23262F] hover:border-blue-500 transition"
        >
          <div className="flex items-center gap-3 mb-1">
            <Grid3X3 className="w-5 h-5 text-[#B1B5C3]" />
            <div className="text-white font-semibold">Приложения</div>
          </div>
          <div className="text-sm text-[#B1B5C3]">Добавление app_id, флаги, включение/выключение в настройках.</div>
        </NavLink>
      </div>
    </div>
  );
};

export default Admin;

